import { dayjs } from "@marekl/adminer/datetime";
import type { Dayjs } from "dayjs";

/**
 * The configured work-day boundary offset in hours, injected by the backend
 * into `window.__KARTIS_CONFIG__` (e.g. 6 = the business day starts at 06:00).
 * Defaults to 0 (midnight boundary) when unset.
 */
export function workDayHoursShift(): number {
  return window.__KARTIS_CONFIG__?.workDayHoursShift ?? 0;
}

/**
 * The current business day as a Prague-local Dayjs at start-of-day.
 *
 * The business day begins `workDayHoursShift` hours after midnight, so between
 * midnight and the shift hour the *current* business day is still the previous
 * calendar date. This mirrors the backend `businessDayStart` logic, so the
 * daily report / overview / KPI date the UI sends matches what the server
 * attributes activity to.
 */
export function businessToday(): Dayjs {
  return dayjs()
    .tz("Europe/Prague")
    .subtract(workDayHoursShift(), "hour")
    .startOf("day");
}
